import { createCRUDHook } from './createCRUDHook';
import { ThompsonDieBoardDto } from 'utils/models';
import { ADD_RE_RULING_ENTRY, TBL_THOMPSON_DIE_BOARD } from './apiEndPoints';

interface ThompsonsDieBoardCustomOperations {
  addReRulingEntry: (id: number) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  ThompsonDieBoardDto,
  ThompsonDieBoardDto[],
  ThompsonsDieBoardCustomOperations
>({
  entityName: 'ThompsonsDieBoard',
  endpoint: TBL_THOMPSON_DIE_BOARD,

  customOperations: (auth) => ({
    addReRulingEntry: async (id: number): Promise<boolean> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          `${TBL_THOMPSON_DIE_BOARD}${ADD_RE_RULING_ENTRY}?id=${id}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return false;
      }
    },
  }),
});

export const ThompsonsDieBoardContext = Context;
export const useThompsonsDieBoardManager = useManager;
export const useThompsonsDieBoard = useConsumer;
